/**
 * 工單完工入庫 create payload（camel）。
 * 禁止：sourceType／sourceId／supplierId（後端固定 WORK_ORDER／工單 id／null）。
 * line 帶 unitId；packages 不送 unitId。
 */
export function buildWorkOrderStockReceiptCreatePayload(values) {
  return {
    receiptDate: values?.receiptDate,
    warehouseId: values?.warehouseId,
    remark: values?.remark ?? null,
    issueReason: values?.issueReason ?? null,
    lines: mapInboundLines(values?.lines),
  };
}

function mapInboundLines(lines = []) {
  return (lines ?? []).map((line) => ({
    mtrId: line?.mtrId,
    unitId: line?.unitId,
    unitPrice: line?.unitPrice ?? 0,
    packages: mapInboundPackages(line?.packages),
  }));
}

function mapInboundPackages(packages = []) {
  return (packages ?? []).map((pkg) => ({
    locationId: pkg?.locationId,
    qty: pkg?.qty,
  }));
}
